
import { Component, Vue, Prop } from 'vue-property-decorator'
import { AppBox } from '@/components'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import CommonAppItemPlatform from '@/components/CommonAppItemPlatform.vue'
import { cloneDeep } from 'lodash'
import { iOSLoginUrl } from '@/utils/fastlane'

@Component({
    components: {
        AppBox,
        FontAwesomeIcon,
        CommonAppItemPlatform,
    },
})
export default class DetailSidebar extends Vue {
    @Prop() public app!: AppEntity

    private onChangeApp(appInfo: AppInfoEntity, platform: string) {
        const updatedApp = cloneDeep(this.app)
        if (platform === 'android') {
            updatedApp.android = appInfo
        } else {
            updatedApp.iOS = appInfo
        }

        this.$store.dispatch('detail/updateHomeApp', updatedApp)
    }

    private onUpdateSession() {
        window.open(iOSLoginUrl(this.app), '_blank')
    }
}
